export  interface ConfigScheduleItem {
    id: number;
    parentId?: number | null;
    itemType: string;
    title: string;
    duration?: number;
    dependencyOnId?: number | null;
    dependencyType?: number | null;
    startOffset?: number;
    completedOnCreation?: boolean;
    sortingIndex?: number;
}


export interface GanttTask{
    id: any;
    parentId?: any | null;
    title: string;
    startDate: Date;
    endDate: Date;
    color: string;
    progress ?: number;
    sortingIndex ?: number;
    itemId?: number;
    itemType?: string;
}

export interface RelativeGanttTask{
    id: number;
    parentId?: number | null;
    startDate: number;
    endDate: number;
}

export interface GanttDependancy{
    id: any;
    taskId: any;
    dependancyOnId: any;
    dependencyType: number;
}

export enum GanttDependencyType {
    FS = 0,
    SS = 1,
    FF = 2,
    SF = 3,
}